<!-- eslint-disable prettier/prettier -->
<template>
  <section class="quotewizard">
    <loader :loading="loading"></loader>
    <div class="container smallcontainer centereverything">
      <div class="title">Let's start with the basics.</div>
      <br /><br />
      <status-component />
      <div class="fieldleft" style="text-align: left">
        <div class="subtitle">
          What type of property do you live in? <red v-pre>*</red>
        </div>
      </div>
      <div class="fieldright" style="text-align: center">
        <select
          v-model="quote.info.propertyType"
          style="max-width: 300px"
          name="propertyType"
          :class="{ validationfield: hasErrors('propertyType') }"
          @change="propertyTypeChange"
        >
          <option value="0">Please Select...</option>
          <option value="A">Apartment/Condominium</option>
          <option value="S">Single Family Home</option>
          <option value="T">Townhouse/Duplex/Triplex</option>
          <option value="D">Dormitory/Student Housing</option>
        </select>
        <validation-error name="propertyType" :errors="validationErrors" />
      </div>
      <div style="clear: both"></div>
      <hr />
      <br />
      <!--------------------------------------------------->
      <div v-if="shouldShowMasonryQuestion">
        <div class="fieldleft" style="text-align: left">
          <div class="subtitle">
            Please select the construction type of dwelling. <red v-pre>*</red>
          </div>
        </div>
        <div class="fieldright" style="text-align: center">
          <input
            id="renter-constructionType-masonry"
            v-model="quote.info.isMasonryConstruction"
            type="radio"
            class="styledradio"
            name="renter-constructionType"
            :value="true"
            @change="validatedFieldChanged"
          /><label
            for="renter-constructionType-masonry"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('renter-constructionType') }"
            >Masonry
          </label>
          <input
            id="renter-constructionType-woodframe"
            v-model="quote.info.isMasonryConstruction"
            type="radio"
            class="styledradio"
            name="renter-constructionType"
            :value="false"
            @change="validatedFieldChanged"
          /><label
            for="renter-constructionType-woodframe"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('renter-constructionType') }"
            >Woodframe</label
          >
          <validation-error name="renter-constructionType" :errors="validationErrors" />
        </div>
        <div style="clear: both"></div>
        <hr />
        <br />
      </div>
      <!--------------------------------------------------->
      <div v-if="quote.info.propertyType == propSingleHome">
        <div class="fieldleft" style="text-align: left">
          <div class="subtitle">
            Is this a Manufactured/Mobile home? <red v-pre>*</red>
          </div>
        </div>
        <div class="fieldright" style="text-align: center">
          <input
            id="renter-manufactured-yes"
            v-model="quote.info.isManufactured"
            type="radio"
            class="styledradio"
            name="renter-manufactured"
            :value="true"
            @change="validatedFieldChanged"
          /><label
            for="renter-manufactured-yes"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('renter-manufactured') }"
            >Yes
          </label>
          <input
            id="renter-manufactured-no"
            v-model="quote.info.isManufactured"
            type="radio"
            class="styledradio"
            name="renter-manufactured"
            :value="false"
            @change="validatedFieldChanged"
          /><label
            for="renter-manufactured-no"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('renter-manufactured') }"
            >No
          </label>
          <validation-error name="renter-manufactured" :errors="validationErrors" />
        </div>
        <div style="clear: both"></div>
        <hr />
        <br />
      </div>
      <!--------------------------------------------------->
      <div class="fieldleft" style="text-align: left">
        <div class="subtitle">
          Does your Lease Contract require all residents at the property to
          carry Renters Insurance? <red v-pre>*</red>
        </div>
      </div>
      <div class="fieldright" style="text-align: center">
        <input
          id="renter-require-no"
          v-model="quote.info.requiredRenters"
          type="radio"
          class="styledradio"
          name="renter-require"
          :value="true"
          @change="validatedFieldChanged"
        /><label
          for="renter-require-no"
          style="margin-left: 5px !important"
          :class="{ validationfield: hasErrors('renter-require') }"
          >Yes
        </label>
        <input
          id="renter-require-yes"
          v-model="quote.info.requiredRenters"
          type="radio"
          class="styledradio"
          name="renter-require"
          :value="false"
          @change="validatedFieldChanged"
        /><label
          for="renter-require-yes"
          style="margin-left: 5px !important"
          :class="{ validationfield: hasErrors('renter-require') }"
          >No
        </label>
        <validation-error name="renter-require" :errors="validationErrors" />
      </div>
      <div style="clear: both"></div>
      <br />
      <hr />
      <br />
      <!--------------------------------------------------->
      <div v-if="quote.address.state.short === 'MD'">
        <div class="fieldleft" style="text-align: left">
          <div class="subtitle">
            Excluding storms, floods and other natural causes, have you had more
            than 3 non-weather related personal property losses in the past
            three years?
            <red v-pre>*</red>
          </div>
          <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
            A loss is any time there’s been a theft, injury or damage to
            property, whether it was covered or not.
          </p>
        </div>
        <div class="fieldright" style="text-align: center">
          <input
            id="threeyear-loss-yes"
            v-model="quote.info.numberOfLosses"
            type="radio"
            class="styledradio"
            name="threeyear-loss"
            value="2"
            @change="hasNotLosses"
          /><label
            for="threeyear-loss-yes"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('threeyear-loss') }"
            >Yes
          </label>
          <input
            id="threeyear-loss-no"
            v-model="quote.info.numberOfLosses"
            type="radio"
            class="styledradio"
            name="threeyear-loss"
            value="0"
            @change="hasNotLosses"
          /><label
            for="threeyear-loss-no"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('threeyear-loss') }"
            >No
          </label>
          <validation-error name="threeyear-loss" :errors="validationErrors" />
        </div>
      </div>
      <div v-else>
        <div class="fieldleft" style="text-align: left">
          <div v-if="quote.address.state.short === 'TX'">
            <div class="subtitle">
              Have you had any losses from theft/burglary, vandalism, fire or
              caused damage to a property in the past 3 years?
              <red v-pre>*</red>
            </div>
            <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
              A loss is any time there’s been a theft, injury or damage to
              property, whether it was covered or not.
            </p>
          </div>
          <div v-else-if="quote.address.state.short === 'FL'">
            <div class="subtitle">
              Excluding 'Acts of God', how many losses have you had in the past three years?
              <red v-pre>*</red>
            </div>
            <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
              A loss is any time there’s been a theft, injury or damage to
              property, whether it was covered or not.
            </p>
          </div>
          <div v-else>
            <div class="subtitle">
              How many losses have you had in the past three years?
              <red v-pre>*</red>
            </div>
            <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
              A loss is any time there’s been a theft, injury or damage to
              property. Excluding natural disasters.
            </p>
          </div>
        </div>
        <div class="fieldright" style="text-align: center">
          <input
            id="threeyear-loss-0"
            v-model="quote.info.numberOfLosses"
            type="radio"
            class="styledradio"
            name="threeyear-loss"
            value="0"
            @change="hasNotLosses"
          /><label
            for="threeyear-loss-0"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('threeyear-loss') }"
            >0
          </label>
          <input
            id="threeyear-loss-1"
            v-model="quote.info.numberOfLosses"
            type="radio"
            class="styledradio"
            name="threeyear-loss"
            value="1"
            @change="hasNotLosses"
          /><label
            for="threeyear-loss-1"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('threeyear-loss') }"
            >1
          </label>
          <input
            v-if="quote.address.state.short !== 'MI'"
            id="threeyear-loss-2"
            v-model="quote.info.numberOfLosses"
            type="radio"
            class="styledradio"
            name="threeyear-loss"
            value="2"
          /><label
            v-if="quote.address.state.short !== 'MI'"
            for="threeyear-loss-2"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('threeyear-loss') }"
            >2+
          </label>
          <validation-error name="threeyear-loss" :errors="validationErrors" />
        </div>
      </div>
      <div style="clear: both"></div>
      <hr />
      <br />
      <!--------------------------------------------------->
      <div v-if="quote.info.numberOfLosses == 1">
        <div class="fieldleft" style="text-align: left">
          <div class="subtitle">
            What was the Date of Loss?
            <red v-pre>*</red>
          </div>
        </div>
        <div class="fieldright" style="text-align: center">
          <input
            id="lastLoss-date"
            v-model="quote.info.lastLossDate"
            style="max-width: 300px"
            type="date"
            :max="yesterday"
            :min="lastThreeYears"
            name="lastLossDate"
            :class="{ validationfield: hasErrors('lastLossDate') }"
            @change="validatedFieldChanged"
          />
          <validation-error name="lastLossDate" :errors="validationErrors" />
        </div>
        <div style="clear: both"></div>
        <hr />
        <br />
      </div>
      <!--------------------------------------------------->
      <div v-if="quote.address.state.short !== 'MI'">
        <div class="fieldleft" style="text-align: left">
          <div class="subtitle">
            Do you own or care for an animal that has caused bodily injury or
            harm? (Excluding service animals)<red v-pre>*</red>
          </div>
          <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
            Service Animals: Service animals are defined as guide dogs, signal
            dogs or any other service animals that are trained to do work or
            perform task for the benefit of an individual with a disability.
          </p>
        </div>
        <div class="fieldright" style="text-align: center">
          <input
            id="harm-person-animal-yes"
            v-model="quote.info.animalHarm"
            type="radio"
            class="styledradio"
            name="harm-person-animal"
            :value="true"
            @change="validatedFieldChanged"
          /><label
            for="harm-person-animal-yes"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('harm-person-animal') }"
            >Yes
          </label>
          <input
            id="harm-person-animal-no"
            v-model="quote.info.animalHarm"
            type="radio"
            class="styledradio"
            name="harm-person-animal"
            :value="false"
            @change="validatedFieldChanged"
          /><label
            for="harm-person-animal-no"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('harm-person-animal') }"
            >No
            </label>
          <validation-error name="harm-person-animal" :errors="validationErrors" />
        </div>
        <div style="clear: both"></div>
        <hr />
        <br />
      </div>
      <!--------------------------------------------------->
      <div v-if="quote.address.state.short === 'RI'">
        <div class="fieldright" style="text-align: left">
          <div class="subtitle">Rhode Island Residents <red v-pre>*</red></div>
          <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
            During the last ten (10) years, has any applicant been indicted for
            or convicted of any degree of crime or fraud, bribery, arson or any
            other arson-related crime in connection with this or any other
            property?
          </p>
        </div>
        <div class="fieldright" style="text-align: center">
          <input
            id="ri-question-yes"
            v-model="quote.info.hasStateDisclosure"
            type="radio"
            class="styledradio"
            name="ri-question"
            :value="true"
            @change="validatedFieldChanged"
          /><label
            for="ri-question-yes"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('ri-question') }"
            >Yes
          </label>
          <input
            id="ri-question-no"
            v-model="quote.info.hasStateDisclosure"
            type="radio"
            class="styledradio"
            name="ri-question"
            :value="false"
            @change="validatedFieldChanged"
          /><label
            for="ri-question-no"
            style="margin-left: 5px !important"
            :class="{ validationfield: hasErrors('ri-question') }"
            >No
          </label>
          <validation-error name="ri-question" :errors="validationErrors" />
        </div>
        <div style="clear: both"></div>
        <hr />
        <br />
      </div>
      <!--------------------------------------------------->
      <div class="fieldleft" style="text-align: left">
        <div class="subtitle">
          Add accident protection for your electronic devices?<red v-pre>*</red>
        </div>
        <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
          Covers cracked screens and liquid damage for your phone, tablet and
          laptop.
        </p>
      </div>
      <div class="fieldright" style="text-align: center">
        <input
          id="add-personal-insurance-yes"
          v-model="quote.hasPersonalInsurance"
          type="radio"
          class="styledradio"
          name="add-personal-insurance"
          :value="true"
          @change="validatedFieldChanged"
        /><label
          for="add-personal-insurance-yes"
          style="margin-left: 5px !important"
          :class="{ validationfield: hasErrors('add-personal-insurance') }"
          >Yes
        </label>
        <input
          id="add-personal-insurance-no"
          v-model="quote.hasPersonalInsurance"
          type="radio"
          class="styledradio"
          name="add-personal-insurance"
          :value="false"
          @change="validatedFieldChanged"
        /><label
          for="add-personal-insurance-no"
          style="margin-left: 5px !important"
          :class="{ validationfield: hasErrors('add-personal-insurance') }"
          >No
        </label>
        <validation-error name="add-personal-insurance" :errors="validationErrors" />
      </div>
      <div style="clear: both"></div>
      <hr />
      <br />
      <!--------------------------------------------------->
      <div class="fieldleft" style="text-align: left">
        <div class="subtitle">
          When do you need your coverage to start? <red v-pre>*</red>
        </div>
        <p style="font-size: 14px; margin-top: 10px; line-height: 22px">
          This will be the effective date of your renters insurance policy.
        </p>
      </div>
      <div class="fieldright" style="text-align: center">
        <input
          id="startcoverage-date"
          v-model="quote.info.coverageStartDate"
          style="max-width: 300px"
          type="date"
          :min="tomorrow"
          :max="todayPlusSixty"
          name="coverageStartDate"
          :class="{ validationfield: hasErrors('coverageStartDate') }"
          @change="quoteChange"
        />
        <validation-error name="coverageStartDate" :errors="validationErrors" />
      </div>

      <div style="clear: both"></div>
      <hr />
      <br /><br /><br />
      <!--------------------------------------------------->
      <div style="text-align: center">
        <button
          :class="{ disabled: !validated }"
          @click="goToPage('quote-quote')"
        >Continue
        </button>
      </div>
      <br /><br /><br /><br /><br /><br />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { PropertyType } from "@/models/QuoteInfo";
import { formatDateForDateInput, stat, scrollTop } from "@/utils/Utils";
import { AssurantData } from "@/api/AssurantData";
import StatusComponent from "@/components/StatusComponent.vue";
import ValidationError from "@/components/ValidationError.vue";
import Loader from "@/components/MainLoader.vue";
import "configurable-date-input-polyfill";
import { Defaults } from "@/models/Defaults";
import { onMounted, inject } from "vue";
import { ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useStatusStore } from "@/stores/root/status";

const props = defineProps({
  anchor: {
    type: String,
    default: "",
  },
});

const title = "Questions";
const loading = ref(false);
const propSingleHome = PropertyType.SingleFamilyHome;
const validationErrors: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const emit = defineEmits(["quote-changed"]);
const inj = inject("$emitter");
const quote = useQuoteStore();

function addDaysToCurrentDateFormated(nrOfDays: number) {
  const d = new Date();
  d.setDate(d.getDate() + nrOfDays);
  return formatDateForDateInput(d);
}

const tomorrow = computed(() => {
  return addDaysToCurrentDateFormated(1);
});

const lastThreeYears: ComputedRef<string> = computed(() => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 3);
  return formatDateForDateInput(d);
});

const yesterday: ComputedRef<string> = computed(() => {
  return addDaysToCurrentDateFormated(-1);
});

onMounted(() => {
  if (quote.address.address.length > 30) {
    quote.address.address = quote.address.address
      .replace(/street/gi, "St")
      .replace(/boulevard/gi, "Blvd")
      .replace(/avenue/gi, "Ave")
      .replace(/road/gi, "Rd")
      .slice(0, 30);
  }
  if (!quote.info.coverageStartDate) {
    quote.info.coverageStartDate = tomorrow.value;
  }
  if (
    quote.address.state.title == "Arkansas" ||
    quote.address.state.title == "Indiana" ||
    quote.address.state.title == "Maine" ||
    quote.address.state.title == "Maryland" ||
    quote.address.state.title == "New Jersey" ||
    quote.address.state.title == "Rhode Island" ||
    quote.address.state.title == "South Dakota"
  ) {
    quote.processingFee = 0;
    quote.monthlyProcessingFee = 0;
  } else {
    quote.processingFee = Defaults.getInstance().processingFee;
    quote.monthlyProcessingFee = Defaults.getInstance().monthlyProcessingFee;
  }
});

const todayPlusSixty = computed(() => {
  return addDaysToCurrentDateFormated(60);
});

const validated: ComputedRef<boolean> = computed(() => {
  let valid =
    quote.info.propertyType != 0 &&
    quote.info.requiredRenters !== undefined &&
    quote.info.numberOfLosses !== undefined &&
    quote.hasPersonalInsurance !== undefined &&
    Boolean(quote.info.coverageStartDate) &&
    +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) >=
      +new Date(tomorrow.value).setHours(0, 0, 0, 0) &&
    +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) <=
      +new Date(todayPlusSixty.value).setHours(0, 0, 0, 0);

  if (quote.address.state.short !== "MI") {
    valid = valid && quote.info.animalHarm !== undefined;
  }

  if (quote.info.propertyType == PropertyType.SingleFamilyHome) {
    valid = valid && quote.info.isManufactured !== undefined;
  }

  if (quote.address.state.short === "RI") {
    valid = valid && quote.info.hasStateDisclosure !== undefined;
  }

  if (quote.address.state.short == "AL" || quote.address.state.short == "NC") {
    valid = valid && quote.info.isMasonryConstruction !== undefined;
  }

  if (quote.info.numberOfLosses == 1) {
    valid =
      valid &&
      Boolean(quote.info.lastLossDate) &&
      +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) >=
        +new Date(lastThreeYears.value).setHours(0, 0, 0, 0) &&
      +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) <=
        +new Date(yesterday.value).setHours(0, 0, 0, 0);
  }

  return valid;
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (quote.info.propertyType == 0) {
    const error = {
      name: "propertyType",
      value: "Please select type of property.",
    };
    validationErrors.value.push(error);
  }

  if (
    quote.info.propertyType == PropertyType.SingleFamilyHome &&
    quote.info.isManufactured === undefined
  ) {
    const error = {
      name: "renter-manufactured",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (quote.info.requiredRenters === undefined) {
    const error = {
      name: "renter-require",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (quote.hasPersonalInsurance === undefined) {
    const error = {
      name: "add-personal-insurance",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (
    quote.address.state.short !== "MI" &&
    quote.info.animalHarm === undefined
  ) {
    const error = {
      name: "harm-person-animal",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (quote.info.numberOfLosses === undefined) {
    const error = {
      name: "threeyear-loss",
      value: "Please fill in the number of losses.",
    };
    validationErrors.value.push(error);
  }

  if (
    quote.address.state.short == "RI" &&
    quote.info.hasStateDisclosure === undefined
  ) {
    const error = {
      name: "ri-question",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (
    (quote.address.state.short == "AL" || quote.address.state.short == "NC") &&
    quote.info.isMasonryConstruction === undefined
  ) {
    const error = {
      name: "renter-constructionType",
      value: "Please select construction type.",
    };
    validationErrors.value.push(error);
  }

  if (!quote.info.coverageStartDate) {
    const error = {
      name: "coverageStartDate",
      value: "Please select coverage start date.",
    };
    validationErrors.value.push(error);
  } else {
    if (
      +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) <
        +new Date(tomorrow.value).setHours(0, 0, 0, 0) ||
      +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) >
        +new Date(todayPlusSixty.value).setHours(0, 0, 0, 0)
    ) {
      const error = {
        name: "coverageStartDate",
        value: "The date must be between tomorrow and 60 days from today.",
      };
      validationErrors.value.push(error);
    }
  }

  if (quote.info.numberOfLosses == 1) {
    if (!quote.info.lastLossDate) {
      const error = {
        name: "lastLossDate",
        value: "Please select last loss date.",
      };
      validationErrors.value.push(error);
    } else {
      if (
        +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) <
          +new Date(lastThreeYears.value).setHours(0, 0, 0, 0) ||
        +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) >
          +new Date(yesterday.value).setHours(0, 0, 0, 0)
      ) {
        const error = {
          name: "lastLossDate",
          value: "The date must be within the last 3 years.",
        };
        validationErrors.value.push(error);
      }
    }
  }
}

async function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollTop();
    return;
  }
  loading.value = true;
  const quoteResult = await AssurantData.readAssurantData(quote, false);
  loading.value = false;

  if (quoteResult.error) {
    if (quoteResult.denialNotice !== "") {
      quote.saveDenialNotice(quoteResult.denialNotice);
      quote.saveResponseMessage(quoteResult.message);
      quote.setQuoteStep("quote-denied");
      return;
    }
    scrollTop();
    stat(statusStore).error(quoteResult.message);
  } else {
    quote.setQuoteStep(command);
  }
}

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  clearValidationMessage(event.target.name);
}

function quoteChange(event: any) {
  (inj as any).emit("quote-changed");
  validatedFieldChanged(event);
}

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}
//this function is not used
// const currentDate = computed(() => {
//   const d = new Date();
//   return formatDateForDateInput(d);
// });

const shouldShowMasonryQuestion = computed(() => {
  return quote.address.state.short == "AL" || quote.address.state.short == "NC";
});

function propertyTypeChange(event: any) {
  if (event.target.value !== propSingleHome) {
    quote.info.isManufactured = false;
  }
  validatedFieldChanged(event);
}

function hasNotLosses(event: any) {
  quote.info.lastLossDate = "";
  validatedFieldChanged(event);
}
</script>
